module.exports = __webpack_public_path__ + "static/media/1 封面.4414722e.JPG";


//////////////////
// WEBPACK FOOTER
// ./src/img/蔓越莓奶酥醬/1 封面.JPG
// module id = 241
// module chunks = 0